"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function TermsSections() {
  const { t } = useLanguage();
  return (
    <section className="bg-white py-14 md:py-16">
      <div className="max-w-[880px] mx-auto px-4 md:px-6">
        <div className="space-y-10 md:space-y-12">

          {/* 1. Service Scope */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.h2Scope")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("terms.scopeText")}
            </p>
          </div>

          {/* 2. Pricing and Payment */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.h2Pricing")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("terms.pricingText")}
            </p>
          </div>

          {/* 3. Workmanship Guarantee */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.h2Guarantee")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("terms.guaranteeText")}
            </p>
          </div>

          {/* 4. Liability and Limitations */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.h2Liability")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("terms.liabilityText")}
            </p>
          </div>

          {/* 5. Disputes */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.h2Disputes")}
            </h2>
            <p className="text-base leading-[1.7] text-[#374151]">
              {t("terms.disputesText")}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-xl md:text-[26px] font-bold text-[#064e3b] mb-3">
              {t("terms.contactTitle")}
            </h2>
            <div className="bg-[#fefce8] rounded-xl p-6 border-l-4 border-[#047857] max-w-[600px]">
              <p className="font-bold text-[#064e3b] text-base mb-2">
                Windows and Doors Repair LLC
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("terms.phone")}{" "}
                <a
                  href="tel:+17863774452"
                  className="text-[#047857] hover:text-[#064e3b] underline font-medium"
                >
                  (786) 377-4452
                </a>
              </p>
              <p className="text-[#374151] text-sm mb-1">
                {t("terms.email")}{" "}
                <a
                  href="mailto:contact@impact-window-repair-miami.com"
                  className="text-[#047857] hover:text-[#064e3b] underline"
                >
                  contact@impact-window-repair-miami.com
                </a>
              </p>
              <p className="text-[#374151] text-sm italic">
                {t("terms.mailingAddress")} 848 Brickell Ave, PH-5, Miami, FL 33131
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}